import { render, staticRenderFns } from "./DownloadLabels.vue?vue&type=template&id=ab9c181c&"
import script from "./DownloadLabels.vue?vue&type=script&lang=js&"
export * from "./DownloadLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports